<template>
<div>

<spinner v-bind:spinner='spinner'></spinner>

 <div class="form-row mt-2">
    <div class="form-group col-md-6">
      <label for="inputEmail4">Data creazione</label>
      <input readonly  type="text" class="form-control" id="input1" v-model="productData.create_at">
    </div>
    <div class="form-group col-md-6">
      <label for="inputPassword4">Data aggiornamento</label>
      <input readonly type="text" class="form-control" id="input2" v-model="productData.update_at">
    </div>
  </div>



<form  name="updateProduct" v-on:submit.prevent="submit()">
    <div class="card bg-light text-dark mb-3">
    <div class="card-body">
    <div class="row">
    <div class="col-md-4">
      <!-- SUPPLIER -->
      <div class="form-group">
        <supplier-select :key="`${componentKey}-1`" v-bind:Id="productData.supplierId" v-bind:isActive="false"></supplier-select>       
      </div>
    </div>
    <div class="col-md-4">
      <!-- SUPPLIER BRAND LIST -->
      <div class="form-group">
        <supplier-brand-select :key="`${componentKey}-2`" @update="setBrand" v-bind:_brand="productData.brand" v-bind:required="true" v-bind:supplierId="productData.supplierId"></supplier-brand-select>      
      </div>
    </div>
    <div class="col-md-4">
      <!-- SKU -->  
      <div class="form-group">
        <label for="codice"><strong>Codice prodotto del Fornitore</strong></label>
        <input required v-model = "productData.sku" type="text" class="form-control bold" placeholder="" id ="sku" name="sku">
      </div>
    </div>
    <!-- ROW -->
    </div>
    </div>
    </div>
    <!--  CARD -->
    <div  class="card bg-light text-dark mb-2">
    
    <div class="card-body">
    <!-- CARD -->

    <div class="row">
    
    <div class="col-md-4">    
      <!-- SUPPLIER LINE -->
      <div class="form-group">
        <line-select :key="`${componentKey}-3`"  v-bind:Id="productData.lineId" v-bind:optionBase="true"  v-bind:supplierId="productData.supplierId" v-bind:isActive="true" @update="setLineId"></line-select>            
      </div>
    </div>
    
    <div class="col-md-4">  
      <!-- CATEGORY -->

      <div class="form-group ">
        
        <!--<category-select :key="`${componentKey}-4`" v-bind:Id="productData.categoryId" v-bind:optionBase="false" v-bind:isActive="true" @update="setCategoryId"></category-select>  -->
        <category-vue-select :key="`${componentKey}-4`" @input="setCategoryId" v-bind:props="category"></category-vue-select>

      </div>
    </div>

    
       
        
    
    <div class="col-md-4">    
      <!-- DESCRIZIONE -->  
      <div class="form-group">
        <label for="descrizione">Descrizione</label>
        <input  v-model="productData.description" type="text" class="form-control bold" placeholder="" id ="descrizione">
      </div>
    </div>

    <!-- ROW -->
    </div>
    
    <div class="row">
    
    <div class ="col-md-4">  
      <!-- DEPARTMENT -->
      <div class="form-group">
        <department-select  :key="`${componentKey}-5`" v-bind:Id="productData.departmentId" @update="setDepartmentId" v-bind:required="true" v-bind:isActive="true" v-bind:type="true"></department-select>         
      </div>
    </div>

    <div class ="col-md-4">
      <!-- SEASON -->    
      <div class="form-group">
        <season-select :key="`${componentKey}-6`" v-bind:Id="productData.seasonId" v-bind:isActive="true" v-bind:type="true"  @update="setSeasonId"></season-select>
      </div>
    </div>
    <div class ="col-md-4">  
      <!-- SEASON YEAR -->
      <div class="form-group">
        <year-select :key="`${componentKey}-7`"  @update="setYear" v-bind:required="true" v-bind:_year="productData.season_year" v-bind:isActive="true"></year-select>   
      </div>  
    </div>
    </div>
    
    <div class="row">
    <div class="col-md-4">    
      <!-- MATERIAL -->
      <div class="form-group">
      <label for="composizione">Composizione</label>
        <input  v-model="productData.material" type="text" class="form-control bold" placeholder="" id ="material">
      </div>
    </div>
    
    <div class="col-md-4">    
      <!-- DIMENSION -->
      <div class="form-group">
        <label for="dimension">Dimensione</label>
        <input  v-model="productData.dimension" type="text" class="form-control bold" placeholder="" id ="dimension">
      </div>
    </div>
    
    <div class="col-md-4">
      <!-- MADE IN -->      
      <div class="form-group">
        <label for="madeIn">Made in</label>
        <input  v-model="productData.madeIn" type="text" class="form-control bold" placeholder="" id ="madeIn">
      </div>
    </div>
    
    </div>
    </div>
    </div>

     <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg" ></alert-box> 
     
     <button :disabled="!productData.supplierId" type="submit"   class="btn btn-primary float-right mt-2 mr-2">
       <i class="fas fa-edit mr-2" aria-hidden="true"></i>
       MODIFICA
        <span v-if="bt_spinner"  class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
       </button> 

       
           
    </form>

  </div>

<!--
  </div>

</div>
-->

</template>
<script>

import api              from '@/api';

import alertBox              from '@/components/common/AlertBox.vue';

import spinner               from '@/components/common/Spinner.vue';
import supplierSelect        from '@/components/common/SupplierSelect.vue'
import supplierBrandSelect   from '@/components/common/SupplierBrandSelect.vue'
import lineSelect            from '@/components/common/LineSelect.vue'
//import categorySelect        from '@/components/common/CategorySelect.vue'
import seasonSelect          from '@/components/common/SeasonSelect.vue'
import departmentSelect      from '@/components/common/DepartmentSelect.vue'
import yearSelect            from '@/components/common/YearSelect.vue'
import categoryVueSelect       from '@/components/common/CategoryVueSelect.vue'
//import select2               from '@/components/common/Select2.vue'
//import 'vue-select/dist/vue-select.css'; 

export default { 
   props : ['item'],
  components: {alertBox,spinner,supplierSelect,supplierBrandSelect,lineSelect,seasonSelect,departmentSelect,yearSelect,categoryVueSelect

  },
  name: '',
  data () {
      return {

        
        productData     : {},

        msg             : {
          title         : ''
        },

        componentKey    : 0,
        
        bt_spinner      : false,
        spinner         : false,
        category        : {'Id':''}
        


     
    
       

        }
    },
    computed: 
    { 
      
    },
   
   /*
    directives: 
    {
      focus: {
      // directive definition
        inserted: function (el) {
          _el.focus()}
       
      }
    },
  */
    created () 
    {
      this.getData();   
      
    },
  
  watch: {
    
  },

  methods: 
  {
   setData(Id)
   {
    //alert(Id)
   }, 
   setYear(Id)
   {
     this.productData.season_year = Id
     
   },
   setDepartmentId(Id)
   {
    this.productData.departmentId = Id
   },
   setCategoryId(Id)
   {
     this.productData.categoryId = Id
   },
   setBrand(Id)
   {
     this.productData.brand = Id
   },
   setSeasonId(Id)
   {
     this.productData.seasonId = Id
   },
   setLineId(Id)
   {
     this.productData.lineId = Id
   },


    async getData()
    {
    
    

    this.spinner = true  
    
    var data      = {'productId' : this.item.productId}
    var sp        = {'sp'        : 'spProductData'}
    var json      = Object.assign(data, sp);
    
    await api.post(json).then(res => {
          
         

          if(res.status==200)
            {
              
              this.productData = res.data.recordsets[0][0]  
              this.category.Id = this.productData.categoryId
              
              this.componentKey+=1
              
              

            }
            else if (res.status==500)
            {              
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data              
              this.msg.type = 1                                    
            } 
            else
            {
                           
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                
            }

          
          }).catch(err => {
                           
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message 
              this.msg.type = 1                
              
          }).finally(() => {
              this.spinner = false
        });
    
    },

    
      
      submit() 
      {
        
        this.saveData()
        
      },  
      async saveData()
      {
              
        this.bt_spinner  = true
        
        

        this.msg.title   = ''
             
        var sp  = {'sp' : 'spUpdateProduct'}
        var json  = Object.assign(this.productData, sp);	
        
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
                           
              this.msg.title = "MODIFICA EFFETTUATA."
              this.msg.body = ''
              this.msg.type  = 0
        
            }
           else if(res.status==500)
           {
               
              this.msg.title = "ATTENZIONE "
              this.msg.body = res.data
              this.msg.type  = 1
                
                    
           } 
           else
            {
               this.msg.title = "ATTENZIONE "              
               this.msg.body = res 
               this.msg.type  = 1 
            } 
          

          }).catch(err => {
              
              
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body = err.message
              this.msg.type  = 1
              
          }).finally(() => {
              this.bt_spinner = false
        });

        
      },        

    }
  
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
label:hover {
   
   cursor    : pointer 
   
}

label{

  _color:blue
  
}
.bold {
font-weight: bolder;
}

/*input {border-color: coral;}*/

.form-text {
  color : red
}


h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}



</style>

